import React, {useState, useEffect} from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DatePicker from 'react-datepicker'
import PeriodRender from '../PeriodRender'
import { mediumFormat } from '../../../timeFunctions/timeFns'
import "./activeRender.css"

export default function ActiveRender (props) {
  const lineBreak = props?.singleLine ? '': <br />
  return <div className="period-caption">
    From <DatePicker className="date-picker" selected={props.from} selectsStart
      startDate={props.from} endDate={props.to}
      onChange={props.onChange} open={props.fromOpen}
      maxDate={props.to}
      dateFormat="MMM d, yyyy HH:mm"
      showTimeInput />
    {lineBreak}
    To <DatePicker className="date-picker" selected={props.to} selectsStart
      startDate={props.from}  endDate={props.to}
      minDate={props.from}
      onChange={props.onFinish} open={props.toOpen}
      dateFormat="MMM d, yyyy HH:mm" 
      showTimeInput />
    </div>;
}

export function PanelRender (props) {
  const [fromDate, setFromDate] = useState(props.from);
  const [toDate, setToDate] = useState(props.to);
  useEffect(() => {
    setFromDate(props.from)
   }, [props.from]);
  useEffect(() => {
    setToDate(props.to)
  }, [props.to])
  function cancel () {
    setFromDate(props.from)
    setToDate(props.to)
    props?.close()
  }
  function midnight() {
    setFromDate(new Date(fromDate.toDateString()))
    setToDate(new Date(toDate.toDateString()))
  }
  function addMonth () {
    const dt = new Date(fromDate)
    dt.setMonth(dt.getMonth()+1)
    setToDate(dt)
  }
  return (
    <>
    <PeriodRender from={mediumFormat (props.from)} to={mediumFormat(props.to)} />
    <Modal show={props?.show ?? false} onHide={cancel} size="lg">
      <Modal.Body>
        <div className='modal-layout'>Start Date
        {onePicker(fromDate, toDate, setFromDate)}</div>
        <div className='modal-mid'>
          <Button className='btnspc' variant="primary" onClick={addMonth}>One Month &gt;</Button>
          <Button className='btnspc' variant="primary" onClick={midnight}>Midnight</Button>
        </div>
        <div className="modal-layout">End Date</div>
        {onePicker(toDate, fromDate, setToDate)}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={cancel}>
          Close
        </Button>
        <Button variant="primary" onClick={()=>props?.save(fromDate, toDate)}>
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}
function onePicker (dt, limit, handler) {
  const dtFmt = "MMM d, yyyy HH:mm"
  const lim = limit > dt ? {maxDate:limit} : {minDate:limit}
  return (
    <DatePicker selected={dt}
      onChange={handler}
      dateFormat={dtFmt}
      {...lim}
      showTimeInput 
      inline
      form="external-form"
    />
  )
}
